import { summarize } from "../../../data/data";

export const getProjectedFundingGapsData = (
  database,
  data,
  sectorIds,
  areaId
) => {
  const indicatorIds = new Set([1, 2, 3]);

  if (!sectorIds) {
    sectorIds = new Set(
      Object.keys(database.sectors).map(id => parseInt(id, 10))
    );
  }

  data = data.filter(
    datum => indicatorIds.has(datum.indicator) && datum.area === areaId
  );

  const sectorData = data
    .filter(datum => sectorIds.has(datum.sector))
    .map(datum => ({
      ...datum,
      year: datum.year || -1
    }));

  let summary = summarize(sectorData, ["indicator", "sector", "year"]);

  const totals = summarize(sectorData, ["indicator", "year"]).map(datum => ({
    ...datum,
    sector: "Total"
  }));

  summary = [...summary, ...totals];

  const absoluteChange = Object.values(
    summary.reduce((result, datum) => {
      if (datum.indicator !== 2) {
        const key = `${datum.indicator}+${datum.sector}`;

        result[key] = result[key] || {
          indicator: datum.indicator,
          sector: datum.sector,
          year: "Change (#)",
          value: 0
        };

        if (datum.year === 2020) {
          result[key].value -= datum.value;
          result[key].initialValue = datum.value;
        } else if (datum.year === 2025) {
          result[key].value += datum.value;
        }
      }

      return result;
    }, {})
  );

  const proportionalChange = absoluteChange.map(datum => ({
    indicator: datum.indicator,
    sector: datum.sector,
    year: "Change (%)",
    value: datum.value / datum.initialValue,
    proportion: true
  }));

  const accumulations = summarize(
    sectorData.filter(datum => datum.year >= 2021 && datum.year <= 2025),
    ["indicator", "sector"]
  ).map(datum => ({
    ...datum,
    year: "Cumulative (5 yr)"
  }));

  const totalAccumulations = summarize(
    sectorData.filter(datum => datum.year >= 2021 && datum.year <= 2025),
    ["indicator", "sector"]
  ).map(datum => ({
    ...datum,
    sector: "Total",
    year: "Cumulative (5 yr)"
  }));

  return [
    ...summary.filter(
      datum =>
        datum.indicator === 2 || datum.year === 2020 || datum.year === 2025
    ),
    ...absoluteChange,
    ...proportionalChange,
    ...accumulations,
    ...totalAccumulations
  ].map(datum => ({
    ...datum,
    indicator: database.indicators[datum.indicator],
    sector: datum.sector !== "Total" ? database.sectors[datum.sector] : "Total",
    year: datum.year === -1 ? "Current" : datum.year.toString()
  }));
};
